import _toConsumableArray from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _objectSpread from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _createForOfIteratorHelper from "D:/work/code/2026/Halov2-Fishery-Upgrade/halov-web/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import dayjs from 'dayjs';
import * as echarts from 'echarts';
import chinaGeoJSON from '@/assets/china-border.json';
import xinjiangGeoJSON from '@/assets/xinjiang-border.json';
export default {
  data: function data() {
    return {
      dayjs: dayjs,
      pageConfig: {
        dicTreeFunName: 'dictionaryCache'
      },
      dicData: {
        typeUpperCode: 'Fishery_Diseases_Type',
        configTypes: [],
        configTypeOptions: {}
      },
      warn_list: [],
      active: -1,
      detail: {},
      show: false,
      openStr: '',
      open: false
    };
  },
  mounted: function mounted() {
    var _this = this;
    this.$api[this.pageConfig.dicTreeFunName](this.dicData.typeUpperCode).then(function (res) {
      if (res.data) {
        _this.dicData.configTypes = res.data;
        var _iterator = _createForOfIteratorHelper(res.data),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            _this.dicData.configTypeOptions[item.code] = item.name;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      _this.$nextTick(function () {
        _this.init1();
        _this.init2();
      });
      _this.getWarn();
    });
  },
  watch: {
    active: function active(to) {
      if (to != -1) {
        this.detail = this.warn_list[to];
        this.show = true;
      }
    },
    show: function show(to) {
      if (!to) {
        this.active = -1;
      }
    }
  },
  methods: {
    init1: function init1() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res, data, total, _iterator2, _step2, item, colorList, shadowColorList, option;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this2.$api['areaWarnReportDiseasesType']();
            case 2:
              res = _context.sent;
              data = [], total = 0;
              _iterator2 = _createForOfIteratorHelper(res.data);
              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  item = _step2.value;
                  data.push({
                    name: _this2.dicData.configTypeOptions[item.latitude],
                    value: item.indicator
                  });
                  total += item.indicator;
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
              _this2.echart1 = echarts.init(document.getElementById('chart1'));
              // 原始色块色值
              colorList = ['#26e098',
              // 病毒性
              '#06c8e8',
              // 真菌性
              '#e6c260',
              // 细菌性
              '#f28844',
              // 寄生虫
              '#f8fafc' // 其他
              ]; // 底层阴影：同颜色 + 透明度 0.3
              shadowColorList = colorList.map(function (color) {
                return color + '08';
              }); // 4D = 透明度30%
              option = {
                backgroundColor: 'transparent',
                tooltip: {
                  trigger: 'item',
                  backgroundColor: 'rgba(0,0,0,0.6)',
                  textStyle: {
                    color: '#fff'
                  }
                },
                title: {
                  text: '{b|疾病总数}\n{a|' + total + '}',
                  left: '34%',
                  top: '40%',
                  itemGap: 10,
                  textStyle: {
                    rich: {
                      b: {
                        color: '#fff',
                        fontSize: 14,
                        padding: 10
                      },
                      a: {
                        color: '#fff',
                        fontSize: 32,
                        fontWeight: 700
                      }
                    }
                  },
                  textAlign: 'center'
                },
                legend: {
                  orient: 'vertical',
                  right: '10',
                  top: 'center',
                  itemWidth: 14,
                  itemHeight: 14,
                  itemGap: 15,
                  textStyle: {
                    color: '#fff',
                    fontSize: 12
                  },
                  formatter: function formatter(params) {
                    var currentItem = data.find(function (item) {
                      return item.name === params;
                    });
                    if (currentItem) {
                      // 直接拼接数值 + 空格 + 百分号
                      return (params.length > 5 ? params.slice(0, 5) + '...' : params) + '  ' + ((currentItem.value / total * 100).toFixed(2) - 0) + ' %';
                    }
                    return params;
                  }
                },
                series: [
                // 第二层：上层实体彩色圆环（主体）
                {
                  type: 'pie',
                  radius: ['55%', '60%'],
                  // 内圈比阴影层大，压住大部分阴影，只露出内侧一圈透明阴影边
                  center: ['35%', '50%'],
                  avoidLabelOverlap: false,
                  itemStyle: {
                    borderColor: '#0c1e36',
                    borderWidth: 2
                  },
                  label: {
                    show: false
                  },
                  labelLine: {
                    show: false
                  },
                  emphasis: {
                    scale: false
                  },
                  data: data.map(function (item, idx) {
                    return _objectSpread(_objectSpread({}, item), {}, {
                      itemStyle: {
                        color: colorList[idx]
                      }
                    });
                  })
                },
                // 第一层：底层分段阴影层（同色系透明向内阴影）
                {
                  type: 'pie',
                  radius: ['40%', '60%'],
                  // 内圈更小，向内延伸阴影区域
                  center: ['35%', '50%'],
                  silent: true,
                  legendHoverLink: false,
                  showLegend: false,
                  avoidLabelOverlap: false,
                  itemStyle: {
                    borderColor: '#0c1e36',
                    borderWidth: 2
                  },
                  label: {
                    show: false
                  },
                  labelLine: {
                    show: false
                  },
                  data: data.map(function (item, idx) {
                    return _objectSpread(_objectSpread({}, item), {}, {
                      itemStyle: {
                        color: shadowColorList[idx]
                      }
                    });
                  })
                }]
              };
              _this2.echart1.setOption(option);
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    init2: function init2() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res, pieData, total, _iterator3, _step3, item, colorArr, option;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this3.$api['areaWarnReportDiseasesName']();
            case 2:
              res = _context2.sent;
              pieData = [], total = 0;
              _iterator3 = _createForOfIteratorHelper(res.data);
              try {
                for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                  item = _step3.value;
                  pieData.push({
                    name: item.latitude,
                    value: item.indicator
                  });
                  total += item.indicator;
                }
              } catch (err) {
                _iterator3.e(err);
              } finally {
                _iterator3.f();
              }
              _this3.echart2 = echarts.init(document.getElementById('chart2'));
              // 颜色数组 严格对照图片色块顺序
              colorArr = ['#f2a878',
              // 暖橘色
              '#a88cf0',
              // 淡紫色
              '#00e0f0',
              // 亮青色
              '#169fb0',
              // 深青绿色
              '#08b8ff',
              // 天蓝色
              '#42c8bc' // 浅湖绿色
              ];
              option = {
                backgroundColor: 'transparent',
                tooltip: {
                  trigger: 'item',
                  backgroundColor: 'rgba(0,0,0,0.55)',
                  textStyle: {
                    color: '#fff'
                  }
                },
                // 图例配置：底部、两列布局
                legend: {
                  orient: 'horizontal',
                  bottom: 10,
                  left: 'center',
                  itemWidth: 13,
                  itemHeight: 13,
                  itemGap: 15,
                  textStyle: {
                    color: '#ffffff',
                    fontSize: 14
                  },
                  // 分成2列展示
                  columns: 2
                },
                series: [{
                  name: '分类统计',
                  type: 'pie',
                  radius: ['25%', '60%'],
                  // 内环空白大小 + 圆环粗细
                  center: ['50%', '42%'],
                  // 饼图整体上下位置
                  avoidLabelOverlap: false,
                  label: {
                    show: false // 圆环内部不显示文字
                  },
                  labelLine: {
                    show: false // 关闭外部引导线
                  },
                  // 鼠标悬浮不放大扇区
                  emphasis: {
                    scale: false
                  },
                  color: colorArr,
                  data: pieData
                }]
              };
              _this3.echart2.setOption(option);
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    getWarn: function getWarn() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var res;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this4.$api['areaWarnQuery']({
                page: 1,
                limit: -1,
                sortField: 'create_time'
              });
            case 2:
              res = _context3.sent;
              _this4.warn_list = res.data || [];
              _context3.next = 6;
              return _this4.$nextTick(function () {
                _this4.initMap();
              });
            case 6:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    initMap: function initMap() {
      var _this5 = this;
      if (this.map) {
        try {
          this.map.destroy();
        } catch (e) {}
        this.map = null;
        document.getElementById('map').innerHTML = '';
      }
      var T = window.T;

      // 1. 创建地图实例
      this.map = new T.Map("map");
      this.map.centerAndZoom(new T.LngLat(85.0, 42.0), 5);

      // 2. 添加卫星底图（用 TileLayer，而不是 setMapType）
      // 因为 setMapType 可能与热力图覆盖物冲突
      var satelliteLayer = new T.TileLayer('http://t0.tianditu.gov.cn/img_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=img&STYLE=default&FORMAT=tiles&TILEMATRIXSET=w&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=9987072a4193b993c432efa0734c3aed');
      this.map.addLayer(satelliteLayer);

      // 3. 添加影像标注图层（地名、路名）
      var labelLayer = new T.TileLayer('http://t0.tianditu.gov.cn/cia_w/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=cia&STYLE=default&FORMAT=tiles&TILEMATRIXSET=w&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}&tk=9987072a4193b993c432efa0734c3aed');
      this.map.addLayer(labelLayer);

      // 4. 绘制国界线（放在最上层）
      this.drawChinaBoundary();

      // 5. 创建热力图（放在国界线下面）
      // const points = [
      //     // 乌鲁木齐（新疆首府，热度最高）
      //     { lng: 87.62, lat: 43.82, count: 200 },
      //     // 伊犁伊宁（北疆河谷）
      //     { lng: 81.27, lat: 43.92, count: 180 },
      //     // 喀什（南疆西大门）
      //     { lng: 75.99, lat: 39.48, count: 150 },
      //     // 库尔勒（南疆交通枢纽）
      //     { lng: 86.17, lat: 41.76, count: 140 },
      //     // 阿克苏
      //     { lng: 80.29, lat: 41.11, count: 120 },
      //     // 阿勒泰（北疆最北）
      //     { lng: 88.13, lat: 47.86, count: 110 },
      //     // 吐鲁番（东疆）
      //     { lng: 89.19, lat: 42.91, count: 100 },
      //     // 和田（南疆西南）
      //     { lng: 79.92, lat: 37.11, count: 90 },
      //     // 克拉玛依（北疆石油城市）
      //     { lng: 84.87, lat: 45.58, count: 80 },
      //     // 哈密（新疆东大门）
      //     { lng: 93.45, lat: 42.82, count: 60 }
      // ];
      if (!this.warn_list.length) {
        return;
      }
      var points = [];
      var _iterator4 = _createForOfIteratorHelper(this.warn_list),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var item = _step4.value;
          points.push({
            lng: item.geoLng,
            lat: item.geoLat,
            count: item.caseCount
          });
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      this.$nextTick(function () {
        _this5.createHeatmap(points);
      });
    },
    drawChinaBoundary: function drawChinaBoundary() {
      var _this6 = this;
      var T = window.T;

      // 从 GeoJSON 中提取所有坐标点
      var allCoordinates = this.extractAllCoordinates(xinjiangGeoJSON);

      // 如果数据太大，可以只绘制前几个省份来测试
      // 这里绘制所有省份
      allCoordinates.forEach(function (coords) {
        // 将坐标数组转换为 T.LngLat 对象数组
        var points = coords.map(function (coord) {
          return new T.LngLat(coord[0], coord[1]);
        });

        // 创建多边形覆盖物（带填充和边框）
        var polygon = new T.Polygon(points, {
          color: '#FFD700',
          weight: 3,
          opacity: 0.9,
          dashArray: '8,4',
          // 实线8px + 空隙4px 交替虚线
          fillColor: 'rgba(255, 215, 0, 0.08)',
          fillOpacity: 0.08,
          lineCap: 'round'
        });
        _this6.map.addOverLay(polygon);
      });
    },
    createHeatmap: function createHeatmap(points) {
      var _this7 = this;
      var T = window.T;
      if (typeof T.HeatmapOverlay !== 'function') {
        console.error('T.HeatmapOverlay 未加载');
        return;
      }
      if (!this.map) {
        console.error('地图实例不存在');
        return;
      }
      if (!points || points.length === 0) {
        console.warn('热力图数据为空');
        return;
      }

      // 确保地图完全加载
      var _ensureMapReady = function ensureMapReady() {
        var retryCount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        try {
          var bounds = _this7.map.getBounds();
          if (bounds) {
            console.log('地图边界获取成功，开始创建热力图');
            _this7._createHeatmapInternal(points);
            return;
          }
        } catch (e) {
          console.warn("\u83B7\u53D6\u5730\u56FE\u8FB9\u754C\u5931\u8D25 (\u5C1D\u8BD5 ".concat(retryCount + 1, "):"), e.message);
        }
        if (retryCount < 5) {
          setTimeout(function () {
            _ensureMapReady(retryCount + 1);
          }, 500);
        } else {
          console.error('地图加载超时，无法创建热力图');
        }
      };
      _ensureMapReady();
    },
    _createHeatmapInternal: function _createHeatmapInternal(points) {
      var _this8 = this;
      try {
        // 移除旧热力图
        if (this.heatmapOverlay) {
          try {
            this.map.removeOverLay(this.heatmapOverlay);
          } catch (e) {
            console.warn('移除旧热力图失败:', e);
          }
          this.heatmapOverlay = null;
        }
        var config = {
          radius: 40,
          gradient: {
            0.2: 'blue',
            0.4: 'cyan',
            0.6: 'lime',
            0.8: 'yellow',
            1.0: 'red'
          }
        };

        // 创建热力图
        try {
          // 尝试传入map实例
          this.heatmapOverlay = new T.HeatmapOverlay(this.map, config);
        } catch (e) {
          // 如果不支持传入map，则不传
          this.heatmapOverlay = new T.HeatmapOverlay(config);
        }

        // 先添加到地图
        this.map.addOverLay(this.heatmapOverlay);

        // 准备数据
        var heatmapData = {
          data: points.map(function (item) {
            return {
              lng: parseFloat(item.lng),
              lat: parseFloat(item.lat),
              count: parseFloat(item.count) || 1
            };
          }),
          max: Math.max.apply(Math, _toConsumableArray(points.map(function (p) {
            return p.count;
          })).concat([300]))
        };

        // 使用requestAnimationFrame确保DOM更新
        requestAnimationFrame(function () {
          setTimeout(function () {
            try {
              _this8.heatmapOverlay.setDataSet(heatmapData);
              console.log('✅ 热力图绘制成功，数据点数量:', points.length);
            } catch (error) {
              console.error('❌ 设置热力图数据失败:', error);
              // 最后的补救方案
              _this8._fallbackHeatmap(points);
            }
          }, 100);
        });
      } catch (error) {
        console.error('❌ 热力图创建失败:', error);
        this._fallbackHeatmap(points);
      }
    },
    // 备用方案：使用简化版热力图
    _fallbackHeatmap: function _fallbackHeatmap(points) {
      console.warn('使用备用方案绘制热力图');
      try {
        // 尝试重新创建，不传任何额外参数
        this.heatmapOverlay = new window.T.HeatmapOverlay({
          radius: 40,
          gradient: {
            0.2: 'blue',
            0.4: 'cyan',
            0.6: 'lime',
            0.8: 'yellow',
            1.0: 'red'
          }
        });
        var heatmapData = {
          data: points.map(function (item) {
            return {
              lng: parseFloat(item.lng),
              lat: parseFloat(item.lat),
              count: parseFloat(item.count) || 1
            };
          }),
          max: Math.max.apply(Math, _toConsumableArray(points.map(function (p) {
            return p.count;
          })).concat([300]))
        };
        this.heatmapOverlay.setDataSet(heatmapData);
        this.map.addOverLay(this.heatmapOverlay);
        console.log('✅ 备用方案成功');
      } catch (error) {
        console.error('❌ 备用方案也失败了:', error);
      }
    }
    /**
     * 递归提取 GeoJSON 中所有坐标点
     * 支持 Polygon 和 MultiPolygon 类型
     */
    ,
    extractAllCoordinates: function extractAllCoordinates(geojson) {
      var result = [];
      var _extract = function extract(geometry) {
        if (!geometry) return;
        if (geometry.type === 'Polygon') {
          // Polygon: coordinates 是 [外环, 内环1, 内环2, ...]
          // 我们只取外环（索引0）来绘制整体轮廓
          result.push(geometry.coordinates[0]);
        } else if (geometry.type === 'MultiPolygon') {
          // MultiPolygon: coordinates 是 [[外环, 内环...], [外环, 内环...], ...]
          geometry.coordinates.forEach(function (polygon) {
            result.push(polygon[0]); // 只取每个多边形的外环
          });
        } else if (geometry.type === 'GeometryCollection') {
          geometry.geometries.forEach(function (geom) {
            return _extract(geom);
          });
        }
      };

      // 遍历所有 features
      if (geojson.features) {
        geojson.features.forEach(function (feature) {
          _extract(feature.geometry);
        });
      } else {
        _extract(geojson);
      }
      return result;
    },
    backClick: function backClick() {
      this.$router.back();
    },
    openClick: function openClick(str) {
      this.openStr = str;
      this.open = true;
    }
  }
};